<template>
  <div class="header_setting tab_content full_page_setting">
    <my_background
      titleWidth="80"
      :title="$t('view_left_sidebar_page_setting_header_setting_265')"
      hiddenIsShow="false"
      :radioValue.sync="h_b.radio_val"
      :bgType.sync="h_b.custom.type"
      :imgUrl.sync="h_b.custom.img"
      @imgScaleChange="
        img_scale => {
          let options = this.$store.state.options.backGroundImageList;
          h_b.custom.background_size = options[img_scale].background_size;
          h_b.custom.background_repeat = options[img_scale].background_repeat;
          h_b.custom.background_position = options[img_scale].background_position;
        }
      "
      @tileEffectChange="
        tile_effect => {
          let options = this.$store.state.options.backGroundImageList;
          h_b.custom.background_size = options[tile_effect].background_size;
          h_b.custom.background_repeat = options[tile_effect].background_repeat;
          h_b.custom.background_position = options[tile_effect].background_position;
        }
      "
      :imgScale.sync="h_b.custom.img_scale"
      :tileEffect.sync="h_b.custom.tile_effect"
      :imgPos.sync="h_b.custom.background_position"
      :colorValue.sync="h_b.custom.color"
    >
    </my_background>
    <div class="setting-item" v-if="String(this.$store.state.app.scrollType) == 'normal'">
      <my_radio
        :title="$t('view_left_sidebar_page_setting_header_setting_266')"
        iconIsShow="left"
        titleWidth="66"
        :tips="$t('view_left_sidebar_page_setting_full_page_setting_260')"
        class="nav-type-title"
        :selectValue.sync="$store.state.myRender.common.fixed_header"
        :option="$store.state.options.topNavType"
        @change="fixed_init"
      >
      </my_radio>
      <div class="setting-img-group setting-nav-style">
        <div
          class="setting-img-item"
          v-for="(item,i) in $store.state.options.fullPageTopNavType"
          :key="i"
          @click="onClickTopNavType(item)"
          @mouseenter="onMouseEnter(item,'header')"
          @mouseleave="onMouseLeave(item)"
        >
          <label
            class="setting-img-label"
            :class="$store.state.myRender.common.header_layout_row_setting== item.value ? 'img-label-checked' : ''"
          >
            <div class="jz_style_img style_item_img"
                 :class="['jz_style_img_' + i + ' style_item_'+i]">
              <img v-if="item.sampleImgVisible" class="gif-sample" :src="item.sampleImgUrl" alt="sample">
            </div>
          </label>
          <p class="setting-img-text">{{ $t(item.label) }}</p>
        </div>
      </div>
      <my_radio
        v-if="$store.state.myRender.common.header_layout_row_setting == 'xuanfu'"
        :title="$t('view_left_sidebar_page_setting_header_setting_267')"
        titleWidth="80"
        class="nav-type-title"
        :selectValue.sync="$store.state.myRender.common.xuanfu_position"
        :option="$store.state.options.xuanfuPositionType"
        @change="templet.reset_header_set_data"
      >
      </my_radio>
    </div>
    <my_radio
      v-if="$store.state.myRender.common.fixed_header === 'true'"
      :title="$t('view_left_sidebar_page_setting_header_setting_268')"
      titleWidth="80"
      :selectValue.sync="$store.state.myRender.common.fixed_height"
      :option="$store.state.options.fixed_height"
      @change="fixed_init"
    >
    </my_radio>
    <my_background
      v-if="$store.state.myRender.common.fixed_header === 'true'"
      titleWidth="80"
      :title="$t('view_left_sidebar_page_setting_header_setting_269')"
      :radioValue.sync="f_b.radio_val"
      :bgType.sync="f_b.custom.type"
      :imgUrl.sync="f_b.custom.img"
      :imgScale.sync="f_b.custom.img_scale"
      :tileEffect.sync="f_b.custom.tile_effect"
      :imgPos.sync="f_b.custom.background_position"
      :colorValue.sync="f_b.custom.color"
      @imgScaleChange="
        img_scale => {
          let options = this.$store.state.options.backGroundImageList;
          f_b.custom.background_size = options[img_scale].background_size;
          f_b.custom.background_repeat = options[img_scale].background_repeat;
          f_b.custom.background_position = options[img_scale].background_position;
        }
      "
      @tileEffectChange="
        tile_effect => {
          let options = this.$store.state.options.backGroundImageList;
          f_b.custom.background_size = options[tile_effect].background_size;
          f_b.custom.background_repeat = options[tile_effect].background_repeat;
          f_b.custom.background_position = options[tile_effect].background_position;
        }
      "
      class="newlyAddedRadioNewline"
    >
    </my_background>
    <my_radio
      :title="$t('view_left_sidebar_page_setting_header_setting_270')"
      iconIsShow="left"
      :tips="$t('view_left_sidebar_page_setting_header_setting_271')"
      titleWidth="65"
      hiddenIsShow="false"
      :selectValue.sync="$store.state.myRender.common.nav_min_width.radio_val"
    >
      <div slot="pull_down_control">
        <my_slider
          class="slider-wrapper"
          titleWidth="50"
          title=" "
          :value.sync="$store.state.myRender.common.nav_min_width.custom.val"
          :min="769"
          :max="1920"
        ></my_slider>
      </div>
    </my_radio>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: 'header_setting',
  computed: {
    h_b() {
      return this.$store.state.myRender.common.header_background
    },
    f_b() {
      return this.$store.state.myRender.common.fixed_background
    }
  },
  methods: {
    onClickTopNavType(item) {
      this.$store.state.myRender.common.header_layout_row_setting = item.value
      setTimeout(() => {
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth"
        })
      }, 200)
    },
    onMouseEnter(item, type) {
      let urlMap = {
        header: {
          'fixed_xuanfu': '/static/image/fullpage/scroll_page_header1.gif',
          'fixed_zhanwei': '/static/image/fullpage/scroll_page_header2.gif',
          'unfixed_xuanfu': '/static/image/fullpage/scroll_page_header3.gif',
          'unfixed_zhanwei': '/static/image/fullpage/scroll_page_header4.gif'
        }
      }
      let url
      if (type === 'header') {
        let fixedStr = String(this.$store.state.myRender.common.fixed_header) === 'true' ? 'fixed' : 'unfixed'
        url = urlMap.header[`${fixedStr}_${item.value}`]
      }
      // 新增属性直接赋值 视图没有自动更新
      this.$set(item, 'sampleImgVisible', true)
      this.$set(item, 'sampleImgUrl', url)
    },
    onMouseLeave(item) {
      this.$set(item, 'sampleImgVisible', false)
    },
    fixed_init() {
     setTimeout(() => {
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth"
        })
      }, 200)
      console.log(1111111111111111)
      this.templet.fixed_init();
    }
  },
  created() {
    if (!this.$store.state.myRender.common.nav_min_width) {
      this.$set(this.$store.state.myRender.common, 'nav_min_width', {
        radio_val: 'default',
        default: {
          val: 768
        },
        custom: {
          val: 900
        }
      })
    }
  }
}
</script>

<style lang="scss">
.header_setting {
  .pull_down_content > div {
    margin-left: 0 !important;
  }

  .my_radio_layer {
    margin-left: 0;
    margin-right: 0;
  }

  .set_two_level .title {
    width: 65px;
    //width: 65px !important;
  }
}

.header_setting .slider-wrapper .set_two_level .title {
  width: 0;
}
// 顶部类型：悬浮/占位
.full_page_setting {
  $main-color: #0078d7;

  &.tab_content {
    padding-left: 25px;
    padding-right: 25px;
  }

  .setting-item {
    padding-top: 10px;
    margin-bottom: 10px;
  }
  .setting-img-group {
    display: flex;
    justify-content: space-between;

    .setting-img-label {
      display: inline-block;
      border: 1px solid #e7e7eb;
      overflow: hidden;
      position: relative;

      &:hover {
        border-color: #5874d8;
      }

      &.img-label-checked {
        border-color: #5874d8;
      }

      &.img-label-checked:after {
        position: absolute;
        right: 0;
        bottom: 0;
        content: "";
        width: 28px;
        height: 24px;
        background: url(/static/image/component.png) no-repeat -197px -24px;
        z-index: 2;
      }
    }

    .style_item_img {
      background: url(/static/image/moduleBg.png) no-repeat;
      width: 70px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: relative;
    }

    .setting-img-text {
      text-align: center;
      line-height: 30px;
    }


    img.gif-sample {
      width: 156px;
      height: 94px;
      vertical-align: top;
    }
  }

  .nav-type-title {
    margin-bottom: 3px;
    width: 250px;
    display: inline-block;
  }

  // 顶部类型：悬浮/占位
  .setting-img-group.setting-nav-style {
    .style_item_img {
      width: 156px;
      height: 94px;
      line-height: 94px;
    }

    .style_item_0 {
      background: url(/static/image/fullpage/scroll_page_header1.png) no-repeat;
    }

    .style_item_1 {
      background: url(/static/image/fullpage/scroll_page_header2.png) no-repeat;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/page_setting/header_setting.vue